import ButtonWithIcon from "../../components/ButtonWithIcon/ButtonWithIcon";
import HeadPage from "../../components/HeadPage/HeadPage";
import RoundGrid from "../../components/RoundGrid2/RoundGrid";
import TopicsPreview from "../../components/TopicsPreview/TopicsPreview";
import VisitUsContent from "../../components/VisitUsContent/VisitUsContent";
import { fetchData } from "../../fetcher";
import TheMallOutletLayout from "../../layouts/TheMallOutletLayout/TheMallOutletLayout";
import styles from "../../styles/pages/visit-us.module.scss";
import Download from "../../public/assets/icons/downloadGold.svg";
import ScrollDown from "../../components/ScrollDown/ScrollDown";
import React, { useState, useRef, useEffect } from "react";
import CardCarousel from "../../components/CardCarousel/CardCarousel";
import axios from "axios";
import Related from "../../components/Related/Related";



const VisitUsPage = ({ menuItems, dataContent }) => {
  const scrollToRef = useRef(null);
  const ids = {
    contact: "contact",
    howto: "howto",
    services: "services",
    booking: 'booking',
    downloads: "downloads",
  };
  const [parent, setParent] = useState();
  const [bookableBrand, setBookableBrand] = useState();
  const [brandToRender, setBrandToSee] = useState();
  const useIsomorphicLayoutEffect =
    typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;
  useIsomorphicLayoutEffect(() => {
    setParent(scrollToRef.current);
  }, [scrollToRef.current])

  useEffect(() => {
    fetchDataBrands();
  }, []);

  const fetchDataBrands = async () => {
    let isMounted = true;

    try {
      const brandsRes = await axios({
        method: 'GET',
        url: `${process.env.NEXT_PUBLIC_FE_SERVICES}`,
      })
      if (isMounted) {

        setBookableBrand(brandsRes.data.services.filter(b => b.enabled == "1"));
      }

    } catch (error) {
      console.error('Error loading map: ' + error);
    }
    return () => {
      isMounted = false;
    }
  }

  const brandCarouselItems = dataContent.brandCarousel.items;
  const brandCarouselItemsName = brandCarouselItems && brandCarouselItems.map((b) => b.name.toLowerCase().trim().replace(' ', ''));


  useEffect(() => {
    if (!bookableBrand) return;
    const bookableBrandname = bookableBrand.map((b) => b.name.toLowerCase().trim().replace(' ', ''))
    let brandToSee = [];
    for (let i = 0; i < brandCarouselItems.length; i++) {
      if (bookableBrandname.includes(brandCarouselItems[i].name.toLowerCase().trim().replace(' ', ''))
          || brandCarouselItems[i].name.toLowerCase().trim().replace(' ', '') == 'gucci') {
        brandToSee.push(brandCarouselItems[i])
      }
    }
    setBrandToSee(brandToSee)
  }, [bookableBrand])

  return (
    <TheMallOutletLayout menuItems={menuItems}>
      <div id="head">
        <HeadPage {...dataContent?.head} scrollToRef={scrollToRef} />
      </div>
      <div
        className={`smallerCenteredSection ${styles.visitUsContent}`}
        ref={scrollToRef}
      >
        <TopicsPreview
          {...dataContent?.content?.topicsPreview}
          topics={dataContent?.content?.topicsPreview.topics}
          idList={Object.values(ids)}
          parent={parent}
        />
        <VisitUsContent
          sections={dataContent?.content?.sections}
          sectionIds={Object.values(ids).slice(0, 2)}
        />
        <div id={ids.services} className={"anchor_section " + styles.roundGrid}>
          <RoundGrid {...dataContent?.content?.roundGrid} />
        </div>
        {/* Booking Section */}
        {dataContent.brandCarousel.properties && <>
          <div
            id={ids.booking}
            className={"anchor_section " + styles.cardCarousel}
          >
            <div className={styles.title}>{dataContent.brandCarousel.properties.data.BOOKING_BRANDS_TITLE}</div>
            <CardCarousel
              listOfBrands={brandToRender}
              centeredSlides
              
              hoverText={dataContent.brandCarousel.hoverText}
            />
          </div>
          {false && <div className={styles.buttonSection}>
            <ButtonWithIcon empty link={dataContent.brandCarousel.link} />
          </div>}
        </>}
        {false && <div id={ids.downloads}
          className={"anchor_section " + styles.downloads}
        >
          <div className={styles.title}>{dataContent.downloads.title}</div>
          <div className={styles.content}>{dataContent.downloads.subtitle}</div>
          <div className={styles.button}>
            <ButtonWithIcon
              link={dataContent.downloads.link}
              
              outline={true}
            // lightGold
            />
          </div>
        </div>}

        <Related related={dataContent.related} />

        {scrollToRef && (
          <div
            className="scroll"
          >
            <ScrollDown selector={scrollToRef} scrollTop />
          </div>
        )}
      </div>
    </TheMallOutletLayout>
  );
};

VisitUsPage.getInitialProps = async (context) => {
  let menuItems = null;
  let dataContent = null;
  const { slug } = context.query;
  console.log('context',context);
  console.log('slug',slug);

  const resmenu = await fetchData("/init", context.query.locale);
  const data = await fetchData(slug, context.query.locale);

  console.log('looaogoagoaog', data.content.sections[0].infos);

  if (resmenu) {
    menuItems = resmenu.menu;
  }

  if (data) {
    dataContent = data;
  }

  return {
    menuItems: menuItems,
    dataContent: dataContent,
  };
};

export default VisitUsPage;
